import styled, { css, keyframes } from 'styled-components';

import { colors } from '../../utils/utils';

const spin = keyframes`
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const animationRuleSpin = css`
    ${spin} 1s infinite linear
`;

const Spinner = styled.div<{
    $size?: string;
    $center?: boolean;
    $thickness?: string;
    $backgroundColor?: string;
    $runnerColor?: string;
}>`
    position: relative;

    width: ${props => props.$size || '20px'};
    height: ${props => props.$size || '20px'};

    margin: ${props => (props.$center ? '0 auto' : '0')};

    border: ${props => props.$thickness || '3px'} solid ${props => props.$backgroundColor || colors.blue.i2x};
    border-left: ${props => props.$thickness || '3px'} solid ${props => props.$runnerColor || colors.white.basic};
    border-radius: 50%;

    font-size: 10px;
    text-indent: -9999em;

    transform: translateZ(0);
    animation: ${animationRuleSpin};

    &:after {
        width: ${props => props.$size || '20px'};
        height: ${props => props.$size || '20px'};
        border-radius: 50%;
    }
`;

export default Spinner;
